module.exports = __webpack_public_path__ + "img/根子柏桥贡园.9dfc9417.png";